import { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { apiPath } from '../services/apiBase';

const api = (url, data) => {
  const token = localStorage.getItem('yamass_token');
  return axios.post(apiPath(url), data, { headers: { Authorization: `Bearer ${token}` } });
};

export function usePayment() {
  const [loading, setLoading] = useState(false);

  // Redirect to bKash payment page
  const payWithBkash = async (orderId) => {
    setLoading(true);
    try {
      const res = await api('/payment/bkash/create', { orderId });
      // Redirect to bKash URL — user completes payment there
      window.location.href = res.data.bkashURL;
    } catch (err) {
      toast.error(err.response?.data?.message || 'bKash payment failed');
      setLoading(false);
    }
  };

  // Execute bKash after redirect callback
  const executeBkash = async (paymentID, orderId) => {
    setLoading(true);
    try {
      const res = await api('/payment/bkash/execute', { paymentID, orderId });
      toast.success('Payment successful!');
      return res.data;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Payment execution failed');
    } finally {
      setLoading(false);
    }
  };

  // Initialize Nagad payment
  const payWithNagad = async (orderId) => {
    setLoading(true);
    try {
      const res = await api('/payment/nagad/init', { orderId });
      window.location.href = res.data.paymentURL;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Nagad payment failed');
      setLoading(false);
    }
  };

  return { payWithBkash, executeBkash, payWithNagad, loading };
}
